module.exports = __webpack_public_path__ + "static/media/machine-empty.89992c34.svg";